import { MAINTANCE_TYPE_CODE } from "../config/constants";
import {
  CAPACITY_TYPE,
  ReservationItemTypes,
  RESERVATION_DISPLAY_TYPE,
} from "../interfaces/home";

/**
 * 由于多处用到获取 serviceItems 参数给后端
 * 根据homepage的获取旧逻辑, 进行封装函数
 */
export const findServiceItemsParam = (reserveItems: ReservationItemTypes[]) => {
  if (!reserveItems) {
    return {
      serviceItems: "",
      repairDescList: [],
      eventCode: "",
      capacityType: CAPACITY_TYPE.NORMAL,
    };
  }
  const selectedItems =
    reserveItems?.filter((serviceItem) => !!serviceItem?.checked) || [];
  const repairDescList: number[] = [];
  const selectedServiceCode: number[] = []; // 常规服务活动
  let eventCode = ""; // 专项服务活动
  selectedItems?.forEach((serviceItem) => {
    if (serviceItem.displayType === RESERVATION_DISPLAY_TYPE.SPECIAL) {
      eventCode = serviceItem.eventCode!;
    } else {
      if (
        serviceItem.code === MAINTANCE_TYPE_CODE.REPAIR &&
        serviceItem.children
      ) {
        // 维修项目
        serviceItem.children?.forEach((subOptionItem) => {
          if (subOptionItem?.checked) {
            repairDescList.push(subOptionItem?.code);
          }
        });
      }
      selectedServiceCode.push(serviceItem.code!);
    }
  });

  return {
    serviceItems: selectedServiceCode.join(","),
    repairDescList,
    eventCode,
    capacityType: eventCode ? CAPACITY_TYPE.SPECIAL : CAPACITY_TYPE.NORMAL,
  };
};
